import Vue from 'vue'
import VueRouter from 'vue-router'
import Ezplay from '../views/Ezplay'
import FarmRunningStatus from '../views/FarmRunningStatus'
import WaterFertilizerScheme from '../views/WaterFertilizerScheme'
import DispatchCenter from '../views/DispatchCenter'
import Ylsfj from '../views/Ylsfj2'
import Ylsfj2 from '../views/Ylsfj3'
import Users from '../views/Users'

Vue.use(VueRouter)

const routes = [
  {
    path: '/ezplay',
    name: 'ezplay',
    component: Ezplay
  },
  {
    path: '/farmRunningStatus',
    name: 'farmRunningStatus',
    component: FarmRunningStatus
  },
  {
    path: '/waterFertilizerScheme',
    name: 'waterFertilizerScheme',
    component: WaterFertilizerScheme
  },
  {
    path: '/dispatchCenter',
    name: 'dispatchCenter',
    component: DispatchCenter
  },
  {
    path: '/users',
    name: 'users',
    component: Users
  },
  // {
  //   path: '/Ylsfj',
  //   name: 'Ylsfj',
  //   component: Ylsfj
  // },
  // {
  //   path: '/Ylsfj2',
  //   name: 'Ylsfj2',
  //   component: Ylsfj2
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
